import { LastLiveClassTakenInterpolationKey, OneSignalLiveClassTakenData, OneSignalLiveClassTakenType, OneSignalTags, ClassTypeToOneSignalTypeMap, OneSignalLiveClassTakenDataMap } from "../types/one-signal-tags";
import { LiveClassDto } from "../types/LiveClassDto";
import { OneSignalService } from "../one-signal.service";
import { UtilsService } from "../utils.service";

export const generateOneSignalTagName = (type: OneSignalLiveClassTakenType, key: OneSignalLiveClassTakenData): OneSignalTags => {
  return `${OneSignalTags.LAST_LIVE_CLASS_TAKEN.replace(LastLiveClassTakenInterpolationKey, type)}-${key}` as OneSignalTags;
};

export const shouldSkipTag = (type: OneSignalLiveClassTakenType, key: OneSignalLiveClassTakenData): boolean => {
  return type === OneSignalLiveClassTakenType.PRIVATE && key === OneSignalLiveClassTakenData.TYPE;
};

export const setLiveClassTags = (
  liveClass: LiveClassDto,
  oneSignalService: OneSignalService,
  valueToSet?: string
): void => {
  const liveClassTypeTag = ClassTypeToOneSignalTypeMap[liveClass.type];

  UtilsService.objectEntries(OneSignalLiveClassTakenDataMap).forEach(([key, value]) => {
    const typedKey = key as OneSignalLiveClassTakenData;
    if (shouldSkipTag(liveClassTypeTag, typedKey)) {
      return;
    }

    const tagValue = typedKey === OneSignalLiveClassTakenData.NAME && valueToSet
      ? valueToSet
      : liveClass[value];

    oneSignalService.setTag(generateOneSignalTagName(liveClassTypeTag, typedKey), tagValue);
  });
};



// WEBPACK FOOTER //
// ./ts/app/shared/helpers/one-signal-tags.helper.ts